"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.addGenerator = exports.isRunning = exports.get = void 0;
var common_sidecar_1 = require("@main/common-sidecar");
var nullAction = function () { };
var _obj = null;
var get = function () {
    if (!_obj) {
        _obj = {
            isRunning: false,
            delayTimeLeft: 0,
            generator: null,
            action: nullAction,
        };
    }
    return _obj;
};
exports.get = get;
var isRunning = function () {
    var obj = exports.get();
    return obj.isRunning || obj.generator !== null;
};
exports.isRunning = isRunning;
var addGenerator = function (gen) {
    var obj = exports.get();
    obj.generator = gen; // TODO: queue up multiple generators
};
exports.addGenerator = addGenerator;
var update = function () {
    var et = common_sidecar_1.common.getUpdateDelta();
    var obj = exports.get();
    if (obj.isRunning) {
        if (obj.delayTimeLeft > 0) {
            obj.delayTimeLeft -= et;
            obj.action();
            return true;
        }
    }
    if (obj.generator) {
        obj.isRunning = true;
        var result = obj.generator.next();
        if (result.done) {
            obj.generator = null;
            obj.isRunning = false;
            return false;
        }
        if (result.value.delay) {
            obj.delayTimeLeft = result.value.delay;
        }
        else {
            obj.delayTimeLeft = 0; // Immediately run next action
        }
        if (result.value.action) {
            obj.action = result.value.action;
        }
        else {
            obj.action = nullAction;
        }
        if (result.value.command) {
            console.log('Generator command:', result.value.command);
        }
        if (result.value.reason) {
            console.log('Generator reason:', result.value.reason);
        }
        return true; // Still running animation
    }
    return false;
};
exports.update = update;
